import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PAXDetailView } from '@/components/PAXDetailView'

const paxDetailSearchSchema = z.object({
  tab: z.enum(['details', 'documents', 'flight-history']).optional().default('details'),
})

export const Route = createFileRoute('/_auth/operations/pax/$passengerId')({
  component: RouteComponent,
  validateSearch: paxDetailSearchSchema,
})

function RouteComponent() {
  const { passengerId } = Route.useParams()
  const { tab } = Route.useSearch()

  return <PAXDetailView passengerId={passengerId} initialTab={tab} backTo="/operations/pax" />
}
